import WorkingLionImageUrl from '../../../assets/aiAssistantThinking.png';
import BackgroundImageUrl from './aiAssistantThinkingBackground.svg';

export const ThinkingModalOverlayBackgroundImageUrl = BackgroundImageUrl;
export const AIAssistantThinkingImageUrl = WorkingLionImageUrl;
